import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var position_left_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M5 5.5h8V4H5v1.5ZM5 20h8v-1.5H5V20ZM19 9H5v6h14V9Z" }) });
export {
  position_left_default as default
};
//# sourceMappingURL=position-left.js.map
